import * as angular from 'angular';

/**
 * Banner block presentation component.
 *
 * This component provides a few options to configure a banner-block
 * callout that contains some type of content.
 */
class BannerBlockController implements angular.IController {
  // bindings
  bannerType: string;
  iconClass: string;

  constructor() {}
}

export const BannerBlockComponent: angular.IComponentOptions = {
  bindings: {
    bannerType: '@',
    iconClass: '@',
  },
  controller: BannerBlockController,
  controllerAs: 'ctrl',
  transclude: true,
  template: `
  <div class="banner-block" ng-class="[ctrl.bannerType]">
    <div ng-if="ctrl.iconClass" class="banner-block-icon">
      <i ng-class="[ctrl.iconClass]"></i>
    </div>
    <ng-transclude></ng-transclude>
  </div>
  `,
};
